/**
 * @fileoverview Provides module menu metadata according to the workspace registry.
 *
 * @purpose Filter registered modules based on configuration and expose menu/current module helpers.
 * @usage Imported by layout wrappers, TopBar helpers, and SideMenu to render navigation lists.
 * @ownership Shared services (core)
 * @dependencies
 * - @/config/modules (module Registry)
 * - @/core/types/module-boundaries (ModuleRegistration type)
 * @restrictions
 * - DO NOT perform network calls; works from static configuration only.
 */
'use client';

import { getAppModules } from 'korvo-app-module-registry';
import { moduleMetadataRegistry } from 'korvo-app-modules';

import { type ModuleRegistration } from '../shared/types/types/module-boundaries';

class ModuleService {
  private modules: ModuleRegistration[];

  constructor() {
    this.modules = moduleMetadataRegistry;
  }

  private getEnabledModules(): ModuleRegistration[] {
    const enabledModuleIds = getAppModules();
    return this.modules.filter(module => enabledModuleIds.includes(module.id));
  }

  getModuleMenuItems() {
    return this.getEnabledModules().map(module => module.menuItem);
  }


  getCurrentModule(path: string) {
    const currentModule = this.getEnabledModules().find(m => path.startsWith(`/${m.id}`));
    return currentModule?.name || 'Home';
  }

  getModuleById(id: string) {
    return this.getEnabledModules().find(m => m.id === id);
  }
}

export const moduleService = new ModuleService();